import { render, staticRenderFns } from "./FlashCard.vue?vue&type=template&id=90bafc9c&scoped=true"
import script from "./FlashCard.vue?vue&type=script&lang=js"
export * from "./FlashCard.vue?vue&type=script&lang=js"
import style0 from "./FlashCard.vue?vue&type=style&index=0&id=90bafc9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bafc9c",
  null
  
)

export default component.exports